import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy]);

export default function setCategoriesSwiper() {
  const categoreisSlider = new Swiper('[data-categories] .swiper', {
    slidesPerView: 2.1,
    spaceBetween: 16,
    speed: 1000,
    watchOverflow: true,
    centerInsufficientSlides: true,
    lazy: {
      checkInView: true,
      loadPrevNext: false,
      loadOnTransitionStart: true,
    },
    pagination: {
      el: '[data-categories] .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '[data-categories] .swiper-button-next',
      prevEl: '[data-categories] .swiper-button-prev',
      disabledClass: '-disabled',
    },
    breakpoints: {
      1025: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  });
}
